// Copyright (c) StrangeBee 2023

import React from 'react';
import { ReportTemplateWidgetEnum } from 'thehive-sdk';
import { useLocalMessage } from '@Helpers/locale';
import { Skeleton } from 'antd';

import './ListWidget.scss';

interface ListWidgetProps {
    _kind: ReportTemplateWidgetEnum;
    fields?: string[];
    logColumns?: string[];
    filter?: any;
}

export const ListWidget = ({ fields, logColumns }: ListWidgetProps) => {
    const i = useLocalMessage();

    return (
        <div className="list-widget__list">
            <div className="list-widget__list__fields">
                {fields?.map((field) => (
                    <div className="list-widget__list__fields__item" key={`field-${field}`}>
                        <span className="list-widget__list__fields__item__title">
                            {i({ defaultMessage: field, id: `column.${field}` })}
                        </span>
                        <span className="list-widget__list__fields__item__content">
                            <Skeleton title={false} paragraph={{ rows: 1, width: `100%` }} />
                        </span>
                    </div>
                ))}
                {logColumns && logColumns.length > 0 && (
                    <>
                        <div className="list-widget__list__fields__item">{i('report-template.list.log.logs')}</div>

                        <div className="list-widget__list__fields__item__logs">
                            <div className="list-widget__list__fields__item__logs__block">
                                <div className="list-widget__list__fields__item__logs__block__log first">
                                    {logColumns[0]}
                                </div>
                                <Skeleton title={false} paragraph={{ rows: 1, width: `95%` }} />
                            </div>

                            <div className="list-widget__list__fields__item__logs__block">
                                <div className="list-widget__list__fields__item__logs__block__log second">
                                    {logColumns[1]}
                                </div>
                                <Skeleton title={false} paragraph={{ rows: 1, width: `95%` }} />
                            </div>
                        </div>
                        <div className="list-widget__list__fields__item__logs__block">
                            <div className="list-widget__list__fields__item__logs__block__log">{logColumns[2]}</div>
                            <Skeleton title={false} paragraph={{ rows: 1, width: `95%` }} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
